import React from "react";
import { useNavigate } from "react-router-dom";
import './MarioJump.css';
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import { Birds, Bricks, Clouds, Obstacles, Sun, KeyMessage } from "./atoms";
import { Mario, LoadingScreen, MobileControls, Score, Title } from "./molecules";


export default function MarioJump() {
    const navigate = useNavigate();
    const isPlay = useSelector((state) => state.engine.play);

    const handleClose = () => {
        navigate("/home");  // Ensure "/home" is a valid route in your main routing configuration
    }

    return (
        <>
            <div style={{ display: "flex", flexDirection: 'column' }}>
                <h4 style={{ textAlign: 'center' }}>Press Enter to start the game</h4>
                <Button variant="contained" style={{ marginTop: 50, width: 100, height: 50 }} onClick={handleClose}>Close Game</Button>
            </div>
            <div className="game">
                {!isPlay && <KeyMessage />}
                <Bricks />
                <Mario />
                <Sun />
                <Clouds />
                <Birds />
                <Obstacles />
                {/* <Score /> */}
            </div>
            <MobileControls />
        </>
    );
};

